"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JsonTypes;
(function (JsonTypes) {
    JsonTypes["BN"] = "BN";
    JsonTypes["Buffer"] = "Buffer";
    JsonTypes["Date"] = "Date";
})(JsonTypes = exports.JsonTypes || (exports.JsonTypes = {}));
//# sourceMappingURL=constants.js.map